import { useTheme } from 'hephaestus/web';
import { useMemo } from 'react';

export const useEntityMenuColors = () => {
  const theme = useTheme();

  return useMemo(() => {
    const { palette } = theme;
    return {
      colors: [
        palette.supportOne60,
        palette.supportTwo60,
        palette.supportThree60,
        palette.supportFour60,
        palette.supportFive60,
        palette.supportSix60,
      ],
      colorsInner: [
        palette.supportOne10,
        palette.supportTwo10,
        palette.supportThree10,
        palette.supportFour10,
        palette.supportFive10,
        palette.supportSix10,
      ],
    };
  }, [theme]);
};
